import React from "react";
import styled from "styled-components";
import { colors } from "../../theme";

// Wordmark + brand mark. Mark uses the existing favicon "e" in brand blue.
export const Logo = ({ light = false, height = 28 }) => (
  <Wrap height={height}>
    <Mark
      src={process.env.PUBLIC_URL + "/favicon.png"}
      alt=""
      style={{ filter: light ? "brightness(0) invert(1)" : "none" }}
    />
    <Word $light={light}>everpesa</Word>
  </Wrap>
);

const Wrap = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 9px;
  height: ${(p) => p.height}px;
`;

const Mark = styled.img`
  height: 100%;
  width: auto;
`;

const Word = styled.span`
  font-family: 'Sora', sans-serif;
  font-weight: 800;
  font-size: 22px;
  letter-spacing: -0.03em;
  color: ${(p) => (p.$light ? "#fff" : colors.ink)};
  line-height: 1;
`;
